import { render, staticRenderFns } from "./leaveapplications.vue?vue&type=template&id=0c0a09b0&scoped=true"
import script from "./leaveapplications.vue?vue&type=script&lang=js"
export * from "./leaveapplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a09b0",
  null
  
)

export default component.exports